import { Pressable } from '@react-aria/interactions'
import { Preview } from './Preview'
import Styles from './SuggestedCategory.module.scss'

import { SuggestedCategoryProps } from './Types'
import { Text } from 'blaze-ui/Text/Text'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

const SuggestedCategory = ({ name, previews, onExpand }: SuggestedCategoryProps) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <Pressable onPress={() => onExpand?.(name)}>
      <div className={Styles.category}>
        <Text color="var(--dark-80)" variant={isMobile ? 'label' : 'secondary'}>
          {name}
        </Text>
        <div className={Styles.grid}>
          {previews.map((preview, i) => (
            <div key={`${preview.src}-${i}`} className={Styles.gridCell}>
              <Preview {...preview} />
            </div>
          ))}
        </div>
      </div>
    </Pressable>
  )
}

export { SuggestedCategory }
